import { useEffect, useRef } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useLayoutPanelManagerStore } from '@ui/stores/pipelinesWorkflow'

export const ModalContainer = ({ modalContent }: { modalContent: JSX.Element | null }) => {
  const outerContainerRef = useRef<HTMLDivElement>(null)

  const { layoutModalConfig, setModalContent } = useLayoutPanelManagerStore(
    useShallow((state) => ({
      layoutModalConfig: state.layoutModalConfig,
      setModalContent: state.setModalContent,
    }))
  )

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        layoutModalConfig.open &&
        outerContainerRef.current &&
        !outerContainerRef.current.firstChild?.contains(event.target as Node)
      ) {
        setModalContent({ content: modalContent, open: false })
      }
    }

    if (layoutModalConfig.open) {
      window.addEventListener('mousedown', handleClickOutside)
      return () => window.removeEventListener('mousedown', handleClickOutside)
    }
  }, [layoutModalConfig.open, modalContent, setModalContent])

  return (
    <div ref={outerContainerRef} className="absolute inset-0 z-10 flex items-center justify-center bg-black/20">
      <div className="flex min-w-[50%] flex-col rounded-xl bg-white">{layoutModalConfig.content}</div>
    </div>
  )
}
